import $ from 'jquery';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

function initIntegrationsArchive() {
    $('.integrations-archive').each(function(){
        let $block = $(this);
        let $childCats = $(this).find('.integrations-archive__block');
        // Set up click event for navigation buttons
        $(this).find('.integrations-archive__nav__item-link').on('click', function(e) {
            e.preventDefault();
            ScrollTrigger.refresh();
            let href = $(this).attr('href');
            $('html, body').animate({ scrollTop: $(href).offset().top - 150}, 250);
        });

        // ScrollTrigger setup
        $childCats.each(function() {
            let $cat = $(this);
            let id = $cat.attr('id');
            ScrollTrigger.create({
                trigger: $cat[0],
                start: 'top center', // Adjust this as needed
                end: 'bottom center',
                onEnter: () => updateActiveLink(id),
                onLeaveBack: () => updateActiveLink(id),
                onLeave: () => clearActiveLink(id),
                onEnterBack: () => updateActiveLink(id)
            });
        });

        function updateActiveLink(id) {
            $block.find('.integrations-archive__nav__item-link').removeClass('active');
            $block.find(`.integrations-archive__nav__item-link[href="#${id}"]`).addClass('active');
        }

        function clearActiveLink(id) {
            $block.find(`.integrations-archive__nav__item-link[href="#${id}"]`).removeClass('active');
        }

        let $searchForm = $(this).find('#integrations-search');
        if($searchForm.length){
            let $input = $searchForm.find('input');
            $searchForm.on('submit' , function(e){
                e.preventDefault();
            });
            let $noResultsMessage = $block.find('.integrations-archive__noresults');
            
            // Add event listener for user typing in the input field
            $input.on('input', function() {
                let searchText = $input.val().toLowerCase(); // Get search input and convert to lowercase for case-insensitive search

                // Track if any items are visible
                let anyVisibleItems = false;

                // Loop through each integration card and check if the title or description contains the search text
                $block.find('.integration-card').each(function() {
                    let $card = $(this);
                    let title = $card.find('.integration-card__title').text().toLowerCase(); // Get the title text
                    let description = $card.find('.integration-card__desc').text().toLowerCase(); // Get the description text

                    // Check if the searchText is found in either title or description
                    if (title.includes(searchText) || description.includes(searchText)) {
                        $card.parent().show(); // Show the card if it matches
                        $card.removeClass('hidden');
                        anyVisibleItems = true; // Mark that at least one item is visible
                    } else {
                        $card.parent().hide(); // Hide the card if it doesn't match
                        $card.addClass('hidden');
                    }
                });

                // After filtering cards, check if the entire block should be hidden
                $block.find('.integrations-archive__block').each(function() {
                    let $catBlock = $(this);
                    
                    // Check if any integration cards inside the block are still visible
                    if ($catBlock.find('.integration-card:not(.hidden)').length > 0) {
                        $catBlock.show(); // Show the block if at least one card is visible
                    } else {
                        $catBlock.hide(); // Hide the block if no cards are visible
                    }

                    let catName = $catBlock.find('h4').text().toLowerCase();
                    
                    if(searchText == catName ){
                        $catBlock.show();
                        $catBlock.find('.integration-card').parent().show().removeClass('hidden');
                        anyVisibleItems = true;
                    }
                });

                // Show "No results found" message if no items are visible
                if (anyVisibleItems) {
                    $noResultsMessage.hide(); // Hide the no results message if there are visible items
                } else {
                    $noResultsMessage.show(); // Show the no results message if no items are visible
                }
            });
        }
    });
}

export { initIntegrationsArchive };
